import { BookabilityCode, BookabilityStatus } from "@clipboard-health/contract-worker-app-bff";

import { type OpenShift } from "./types";

export function isWindowedOutShift(shift: OpenShift) {
  return (
    shift.attributes.bookability?.status === BookabilityStatus.UNBOOKABLE &&
    shift.attributes.bookability?.reasons.some(
      (reason) => reason.code === BookabilityCode.NO_ACTIVE_ACCESS_WINDOW
    )
  );
}

export function extractWindowRestriction(
  bookability: OpenShift["attributes"]["bookability"]
): string | undefined {
  if (bookability?.status !== BookabilityStatus.UNBOOKABLE) {
    return undefined;
  }

  return bookability?.reasons.find(
    (reason) => reason.code === BookabilityCode.NO_ACTIVE_ACCESS_WINDOW
  )?.metadata.accessWindowType;
}

export function extractWindowRestrictionScoreThreshold(
  bookability: OpenShift["attributes"]["bookability"]
): number | undefined {
  if (bookability?.status !== BookabilityStatus.UNBOOKABLE) {
    return undefined;
  }

  return bookability?.reasons.find(
    (reason) => reason.code === BookabilityCode.NO_ACTIVE_ACCESS_WINDOW
  )?.metadata.accessWindowScoreThreshold;
}
